<script setup lang="ts">
import { withTrailingSlash, withLeadingSlash, joinURL } from "ufo";
import { useRuntimeConfig, computed, resolveComponent } from "#imports";

const imgComponent = useRuntimeConfig().public.mdc.useNuxtImage ? resolveComponent("NuxtImg") : "img";

const props = defineProps({
  src: {
    type: String,
    default: "",
  },
  alt: {
    type: String,
    default: "",
  },
  width: {
    type: [String, Number],
    default: undefined,
  },
  height: {
    type: [String, Number],
    default: undefined,
  },
});

const refinedSrc = computed(() => {
  if (props.src?.startsWith("/") && !props.src.startsWith("//")) {
    const base = withLeadingSlash(withTrailingSlash(useRuntimeConfig().app.baseURL));
    if (base !== "/" && !props.src.startsWith(base)) {
      return joinURL(base, props.src);
    }
  }
  return props.src;
});
</script>

<template>
  <div class="my-8 flex justify-center">
    <figure :style="`width: ${width}px`">
      <component :is="imgComponent" :src="refinedSrc" :alt="alt" :width="width" :height="height" class="m-0" />

      <figcaption class="mt-0 pt-2 text-center italic">{{ alt }}</figcaption>
    </figure>
  </div>
</template>
